module.exports = __webpack_public_path__ + "static/main2-60a711500996d31ad8ad52428e46e505.webm";